import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import { admin_market_analysis_update, get_market_analysis_list } from "../admin.api";
import { useParams } from "react-router-dom";

import "./view.css";
import { FormValidate } from "../../../components/formValidate";
let required = ["opportunity"];

export default function EditMarketAnalysis(props) {
  const [basicData, setBasicData] = useState({});
  const selectedParam = useParams();
  const locationRow = props?.location?.state?.row;

  const getMarketAnalysisDetailsFromList = async () => {
    if (!selectedParam?.id) {
      console.error("selectedParam.id is undefined:", selectedParam);
      return;
    }

    setIsActive(true);
    try {
      const res = await get_market_analysis_list();
      const list = Array.isArray(res) ? res : [];
      const row = list.find((x) => String(x?.id) === String(selectedParam.id));

      if (row) {
        setBasicData(row);
      } else {
        setSnackMessage("Record not found");
        setIsSnackError(true);
        setSnackOpen(true);
      }
    } catch (err) {
      console.error("Error fetching Market Analysis list:", err);
      setSnackMessage(err?.response?.data?.message || err?.message || "Failed to fetch list");
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    if (locationRow) {
      setBasicData(locationRow);
    }
    getMarketAnalysisDetailsFromList();
  }, [selectedParam?.id]);

  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = basicData;
    data = {
      ...data,

      [name]: value,
    };
    setBasicData(data);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = FormValidate(basicData, required);
    setIsActive(true);
    if (Object.keys(errors).length === 0) {
      let id = basicData?.id;
      admin_market_analysis_update(id, { opportunity: basicData?.opportunity })
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/market-analysis");
    }
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Edit Market Analysis</b>
        </h6>
        <hr />
        <button
          type="button"
          className="btn btn-primary btn-sm  mb-3"
          onClick={(e) => {
            props.history.push("/market-analysis");
          }}
        >
          Back
        </button>

        <div className="row">
          <div className="col-12">
            <TextField
              fullwidth
              label="Opportunity"
              required
              value={basicData?.opportunity ?? ""}
              onChange={(e) => handleChange(e)}
              name="opportunity"
              id="opportunity"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12 mt-3">
            <button type="button" className="btn btn-dark" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
